import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { SortDirection, SortTypes } from '@/types/all-profiles.types';

export const setAllProfilesSort = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<SortTypes>((state, action) => {
    if (state.allProfiles.sort === action.payload) {
      state.allProfiles.sortDirection =
        state.allProfiles.sortDirection === SortDirection.up ? SortDirection.down : SortDirection.up;
    } else {
      state.allProfiles.sort = action.payload;
      state.allProfiles.sortDirection = SortDirection.up;
    }
  });
